/**
 * DevExtreme (ui/tooltip.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = require("./tooltip/tooltip");
module.exports.show = require("./tooltip/ui.tooltip").show;
module.exports.hide = require("./tooltip/ui.tooltip").hide;
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/tooltip.js
// module id = 222
// module chunks = 0